<template>
  <div v-if="showAddressSection" class="street-section">
    <v-row>
      <v-col cols="12" sm="10">
        <div class="street-field">
          <span class="label">Адрес доставки:</span>
          <v-text-field
            v-model="streetAddress"
            hide-details="auto"
            class="text-field"
            disabled
            flat
            solo
          />
        </div>
      </v-col>
      <v-col cols="12" sm="2">
        <span class="label">Дом:</span>
        <v-text-field
          v-model="house"
          hide-details="auto"
          class="text-field"
          readonly
          flat
          solo
        />
      </v-col>
    </v-row>

    <v-row class="address-inputs">
      <v-col sm="3">
        <span class="label">Кв/офис:</span>
        <v-text-field
          v-model="apartmentNumber"
          @focus="currentKeyboard = 'apartment'"
          hide-details="auto"
          class="text-field"
          disabled
          flat
          solo
        />
      </v-col>
      <v-col sm="3">
        <span class="label">Этаж:</span>
        <v-text-field
          v-model="floor"
          @focus="currentKeyboard = 'floor'"
          hide-details="auto"
          class="text-field"
          disabled
          flat
          solo
        />
      </v-col>
      <v-col sm="3">
        <span class="label">Подъезд:</span>
        <v-text-field
          v-model="entry"
          @focus="currentKeyboard = 'entry'"
          hide-details="auto"
          class="text-field"
          disabled
          flat
          solo
        />
      </v-col>
    </v-row>

    <div class="address-info">
      <div>
        <div v-if="polygonInfoLabel" class="polygon-info">
          Филиал: {{ polygonInfoLabel }}
        </div>
        <div v-else class="polygon-error">
          <font-awesome-icon icon="exclamation-triangle" /> Адрес не входит в зону доставки!
          <span v-if="!hasGeo">Координаты не определены</span>
        </div>
      </div>

      <div class="geo-info">
        <a v-if="hasGeo" :href="mapLink" @click.stop="" target="_blank">
          <font-awesome-icon icon="map-marker-alt" />
          Посмотреть на карте</a>
      </div>
    </div>
  </div>
</template>

<script>
  import _ from 'lodash'

  export default {
    name: 'DeliveryAddressInfo',
    props: {
      address: {
        type: Object,
        default: () => ({}),
      },
    },
    computed: {
      showAddressSection () {
        return !_.isEmpty(this.address)
      },
      streetAddress () {
        return (this.address?.shortCity ? `${this.address?.shortCity}, ` : '') +
        this.address?.street
      },
      house () {
        return this.address?.house
      },
      getClientFloor: (state) => {
        return state.clientAddress ? state.clientAddress.floor : ''
      },
      getClientEntry: (state) => {
        return state.clientAddress ? state.clientAddress.entry : ''
      },
      getClientApartmentNumber: (state) => {
        return state.clientAddress ? state.clientAddress.apartmentNumber : ''
      },
    },
  }
</script>

<style scoped lang="less">

</style>
